export { PageNewsCrawlerComponent as PageNewsCrawler } from './component'
import './index.scss'


// WEBPACK FOOTER //
// ./src/pages/news-crawler/index.tsx